import { IAddress } from '@ucheba/store/events/id/types'
import { useCallback, useMemo, useState } from 'react'

export const useEventPageLocation = (locationsWithPoint: IAddress[]): any => {
  const [zoom, setZoom] = useState(11)
  const [center, setCenter] = useState(
    locationsWithPoint.length && [
      locationsWithPoint[0]?.point?.longitude,
      locationsWithPoint[0]?.point?.latitude,
    ]
  )
  const mapData = useMemo(
    () => ({
      center,
      zoom,
    }),
    [zoom, center]
  )
  const onAddressClick = useCallback((lan, lat) => {
    setCenter([lan, lat])
    setZoom(13)
  }, [])

  return {
    onAddressClick,
    mapData,
  }
}
